import paperQuill from '@images/home/paper-quill.png'
import Component from '@glimmer/component'
import { HomeTile } from 'teacher-ui-client/components/home/tile'
import { t } from 'ember-intl'
import UiButtonLink from 'teacher-ui-client/components/ui-button/link'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { subscriptionTypeToThemeKey } from 'teacher-ui-client/utils/themes'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import config from 'teacher-ui-client/config/environment'
import { join } from 'teacher-ui-client/utils/uri'

const ewiUrl = join(config.readingEggsBaseUrl, 'writing/teacher_portal/exciting-writing-ideas').href

export class WritingIdeas extends Component {
  get paperQuillPng() {
    return paperQuill
  }

  get themeKey() {
    return subscriptionTypeToThemeKey(SubscriptionType.Writing)
  }

  <template>
    <HomeTile @themeKey={{this.themeKey}} @title={{t "pages.home.panels.writingIdeas.title"}}>
      <div class="space-y-3 bg-white p-3">
        <div class="flex h-28 items-start">
          <img class="mr-6" src={{this.paperQuillPng}} alt={{t "pages.home.panels.writingIdeas.imageAlt"}} />
          <p class="mb-3">{{t "pages.home.panels.writingIdeas.description"}}</p>
        </div>
        <div class="text-center">
          <UiButtonLink href={{ewiUrl}} @appearance={{ButtonAppearance.regular}}>
            {{t "pages.home.panels.writingIdeas.viewButtonLabel"}}
          </UiButtonLink>
        </div>
      </div>
    </HomeTile>
  </template>
}

export default WritingIdeas
